const DATA_BASE = {
    D: { id: 'D', descricao: 'Padrão' },
    D1: { id: 'D1', descricao: 'D-1' },
    M: { id: 'M', descricao: 'Primeiro dia do mês' },
    A: { id: 'A', descricao: 'Primeiro dia do ano' },
    MU: { id: 'MU', descricao: 'Primeiro dia útil do mês' },
    AU: { id: 'AU', descricao: 'Primeiro dia útil do ano' },
    DU: { id: 'DU', descricao: 'Dia útil' },
    M1: { id: 'M1', descricao: 'Primeiro dia do mês anterior' }
};
module.exports = DATA_BASE;

// Enum DBCnsDataBase
//     Padrao = -1
//     DMenosUm = 1
//     PrimeiroDiaDoMes = 2
//     PrimeiroDiaDoAno = 3
//     PrimeiroDiaUtilDoMes = 4
//     PrimeiroDiaUtilDoAno = 5
//     DiaUtil = 6
//     PrimeiroDiaDoMesAnterior = 7
// End Enum
